<template>
  <div class="qty mt-5" :class="classes">
    <span @click="substract" class="minus bg-dark">-</span>
    <input
      type="number"
      class="count"
      name="qty"
      v-model="value"
      min="1"
      oninput="validity.valid||(value='');"
      @input="changeInput($event)"
    />
    <span @click="add" class="plus bg-dark">+</span>
  </div>
</template>

<script>
import("./style.css");

export default {
  name: "PlusMinusInput",
  props: {
    value: {
      type: Number,
      default: 1,
    },
    classes: {
      type: String,
      default: "",
    },
  },
  methods: {
    add() {
      this.value++;
      this.$emit("count", this.value);
    },
    substract() {
      if (this.value > 1) {
        this.value--;
        this.$emit("count", this.value);
      }
    },
    changeInput(event) {
      

      // this.value=event.v;
      this.$emit("count", this.value);
    },
  },
};
</script>
